import config from 'config';
import Utils  from 'Utils';


/**
 * Validation class
 */
class Validation {
  /**
   * [constructor description]
   * @return {[type]} [description]
   */
  constructor() {
    this.$el            = $('.js-validation');
    this.$form          = $('.mw_wp_form form');
    this.$confirm       = $('.mw_wp_form_confirm');
    this.$submitConfirm = $('input[name="submitConfirm"]');
    this.$req           = $('[class^="js-validation-req"]');
    this.$other         = $('input.js-validation-other');
    this.$otherInput    = $('input[value="その他"]');
    this.$typeInput     = $('input[name="type"]');
    this.$businessInput = $('input[name="business_name"]')
    this.$postInput     = $('input[name="post_name"]')
    this.reqNames       = [];

    // フォームがあれば実行
    if (this.$el.length > 0) {
      this.init();
      this.eventHandler();
    }

    // 確認画面の場合
    if (this.$confirm.length > 0) {
      $('.js-send-status').remove();
    }
  }

  /**
   * イベント管理関数
   * @return {[type]} [description]
   */
  eventHandler() {
    this.$submitConfirm.on('click', (ev) => this.submitHandler(ev));

    this.$other.on('blur', (ev) => {
      let $parent = $(ev.currentTarget).parents('.p-outline__items');
      let $otherInput = $parent.find('input[value="その他"]');
      this.chekcOther($otherInput);
    });
    this.$otherInput.on('change', (ev) => this.otherInputHandler(ev));

    this.$req.on('blur', (ev) => this.blurHandler(ev));

    this.$businessInput.on('blur', (ev) => this.checkBusiness());
    this.$postInput.on('blur', (ev) => this.checkPost());
    this.$typeInput.on('change', (ev) => {
      this.checkBusiness();
      this.checkPost();
    });
  }


  /**
   * 初期設定
   * @return {[type]} [description]
   */
  init() {
    this.$other.prop('disabled', true);
    this.getReqName();
  }


  /**
   * submitボタンclick時に呼ばれる関数
   * @param  {[type]} ev [description]
   * @return {[type]}    [description]
   */
  submitHandler(ev) {
    ev.preventDefault();
    this.check();
  }


  otherInputHandler(ev) {
    let $current = $(ev.currentTarget);
    let $parent = $current.parents('.p-outline__items');
    let val = $current.filter(':checked').val();

    $parent.find('.js-validation-other').prop('disabled', !val);

    if (!val) {
      $parent.find('.js-validation-other').val('');
    }
  }


  blurHandler(ev) {
    this.chekcReqVal($(ev.currentTarget));
  }


  /**
   * 必須要素のname属性を配列に格納する
   * @return {[type]} [description]
   */
  getReqName() {
    this.$req.each((i, v) => {
      this.reqNames.push($(v).attr('name'));
    });

    this.reqNames = _.unique(this.reqNames);
  }


  /** 
   * エラーチェック
   * @return {[type]} [description]
   */
  check(isSubmit = true) {
    let errorCount = 0;

    // 必須項目
    _.each(this.reqNames, (v) => {
      let isCheck = this.chekcReqVal($(`[name="${v}"]`));

      // 入力または選択されていない場合
      if (!isCheck) {
        errorCount++;
      }
    });

    // その他チェックボックス
    this.$otherInput.each((i, v) => {
      let isOtherCheck = this.chekcOther($(v));

      // チェックが入っていて入力欄が空の場合エラーを表示
      if (!isOtherCheck) {
        errorCount++;
      }
    });

    // 法人チェック
    if (!this.checkBusiness()) {
      errorCount++;
    }
    if (!this.checkPost()) {
      errorCount++;
    }

    // ボタンを活性に
    this.$submitConfirm.prop('disabled', false);

    // エラーがなければsubmit
    if (errorCount == 0 && isSubmit) {
      this.$form[0].submit();
    } else {
      let $topError = $('.js-validation-error:visible').eq(0);
      let $topErrorParents = $topError.parents('.p-outline__items');
      let errorTop = $topErrorParents.offset().top;

      $('body,html').animate({
        scrollTop: errorTop
      }, 500);
    }
  }

  chekcReqVal($input) {
    let type = $input.attr('type');
    let val = '';
    let className = $input.attr('class');
    let splitClassName = className.split('js-validation-req-');
    let $error = $(`.js-validation-error[data-name="${splitClassName[splitClassName.length-1]}"]`);
    let $errorEmail = $('.js-validation-error[data-name="email-format"]');
    let check = false;

    if (type == 'checkbox') {
      val = $input.filter(':checked').val();
    } else {
      val = $input.val();
    }

    // 入力または選択されていない場合
    if (!val) {
      $error.show();
      $errorEmail.hide();
      check = false;
    } else if (type == 'email' && !val.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
      $error.hide();
      $errorEmail.show();
      check = false;
    } else {
      $error.hide();
      $errorEmail.hide();
      check = true;
    }

    return check;
  }

  chekcOther($input) {
    let otherVal    = $input.filter(':checked').val();
    let $parent     = $input.parents('.p-outline__items');
    let $otherInput = $parent.find('.js-validation-other');
    let $otherError = $parent.find('.js-validation-error[data-name="other"]');
    let check = false;

    // チェックが入っていて入力欄が空の場合エラーを表示
    if (otherVal && !$otherInput.val()) {
      $otherError.show();
      check = false;
    } else {
      $otherError.hide();
      check = true;
    }

    return check;
  }


  checkBusiness() {
    let typeVal = this.$typeInput.filter(':checked').val();
    let $input = $('input[name="business_name"]');
    let check = false;

    if (typeVal == '法人') {
      if (!$input.val()) {
        $('.js-validation-error[data-name="business_name"]').show();
        check = false;
      } else {
        $('.js-validation-error[data-name="business_name"]').hide();
        check = true;
      }
    } else {
      $('.js-validation-error[data-name="business_name"]').hide();
      check = true;
    }

    return check;
  }


  checkPost() {
    let typeVal = this.$typeInput.filter(':checked').val();
    let $input = $('input[name="post_name"]');
    let check = false;

    if (typeVal == '法人') {
      if (!$input.val()) {
        $('.js-validation-error[data-name="post_name"]').show();
        check = false;
      } else {
        $('.js-validation-error[data-name="post_name"]').hide();
        check = true;
      }
    } else {
      $('.js-validation-error[data-name="post_name"]').hide();
      check = true;
    }

    return check;
  }
}

export default Validation;



// WEBPACK FOOTER //
// ./src/js/modules/Validation.js